<template>
  <span v-if="debugMode" >
    TOTAL | PILED | OPEN | FOUND | <br>
    {{ total }} |
    {{ piled }} |
    {{ open }} |
    {{ found }} |
  </span>
  <div id="status-bar">
    <span class="segment piled" :style="'width: ' + piled / total * 100 + '%;'">
      <span v-if="piled > 0">{{ piled }}</span>
    </span>
    <span class="segment open" :style="'width: ' + open / total * 100 + '%;'">
      <span v-if="open > 0">{{ open }}</span>
    </span>
    <span class="segment found" :style="'width: ' + found / total * 100 + '%;'">
      <span v-if="found > 0">{{ found }}</span>
    </span>
  </div>
</template>

<script>
import config from "@/assets/config.json";
import designSets from "@/assets/designSets.json";

export default {
  name: 'StatusBar',
  props: {
    total: {
      type: Number,
      required: true
    },
    piled: {
      type: Number,
      required: true
    },
    open: {
      type: Number,
      required: true
    },
    found: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      debugMode: config.debugMode,
      cardColors: designSets[config.activeDesignId].cardColors,
      /*
      "basic": "#EFECEA",
      "border": "#4D4D4D",
      "hover": "#E6E6E6",
      "active": "#D8D0CA",
      "valid": "#0F8342",
      "invalid": "#A92323"
      */
      symbolColors: designSets[config.activeDesignId].symbols.colors,
    }
  }
}
</script>
<style scoped>

#status-bar {
  max-width: 800px;
  margin: 5px;

  .segment {
    display: inline-block;
    height: 20px;
    span {
      padding: 2px;
    }
  }

  .piled {
    background-color: v-bind('cardColors.basic');
  }

  .open {
    background-color: v-bind('cardColors.active');
  }

  .found {
    background-color: v-bind('cardColors.valid');
  }
}

</style>